module.exports = __webpack_public_path__ + "img/27001.78e3f9af.png";